"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timezones = void 0;
var angular_1 = __importDefault(require("angular"));
exports.Timezones = angular_1.default
    .module("constants.timezones", [])
    .constant("TIMEZONES", [
    {
        name: "Eastern",
        code: "America/New_York",
    },
    {
        name: "Pacific",
        code: "America/Los_Angeles",
    },
    {
        name: "Mountain",
        code: "America/Denver",
    },
    {
        name: "Mountain (No Daylight Saving Time)",
        code: "America/Phoenix",
    },
    {
        name: "Central",
        code: "America/Chicago",
    },
]);
